var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTechnologyOutlineCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 32.5,
    viewBox: "0 0 32.5 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.708 6.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.965,18.941a1.355,1.355,0,0,1-1.13-1.4l.017-.157L13.56,1.133A1.356,1.356,0,0,1,14.961,0l.157.017a1.354,1.354,0,0,1,1.13,1.4l-.017.157-2.708,16.25a1.355,1.355,0,0,1-1.336,1.132A1.369,1.369,0,0,1,11.965,18.941ZM5.941,15.967l-.128-.113L.4,10.438A1.356,1.356,0,0,1,.284,8.65L.4,8.522,5.813,3.106A1.355,1.355,0,0,1,7.841,4.894l-.113.127L3.27,9.48l4.458,4.459a1.353,1.353,0,0,1,.113,1.787l-.113.128a1.354,1.354,0,0,1-1.787.113Zm13.414-.113a1.354,1.354,0,0,1-.112-1.788l.112-.127L23.813,9.48,19.355,5.02a1.353,1.353,0,0,1-.112-1.787l.112-.128a1.354,1.354,0,0,1,1.788-.113l.127.113,5.417,5.416A1.356,1.356,0,0,1,26.8,10.31l-.112.128L21.27,15.854a1.353,1.353,0,0,1-1.915,0Z",
    transform: "translate(0 0)",
    fill: "#292929"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTechnologyOutlineCode);
export default __webpack_public_path__ + "static/media/Icon-Technology-Outline-Code.2a8b71d3a2c4ef24af5faf690fb85183.svg";
export { ForwardRef as ReactComponent };